export default __webpack_public_path__ + "static/media/parallelRulerIcon.50dd6565.svg";